import { render } from "./AppModal.vue?vue&type=template&id=22b20f14"
import script from "./AppModal.vue?vue&type=script&lang=js"
export * from "./AppModal.vue?vue&type=script&lang=js"

import "./AppModal.vue?vue&type=style&index=0&id=22b20f14&lang=scss"

import exportComponent from "/Users/billyhan/Sites/sol-v3/web/wp-content/themes/swinburne/assets/Eligibility/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__